export class NumberParser {
    public static tryParseHexadecimalStringToInt(hexadecimalErrorCode?: string): number | BigInt | undefined {
        if (!hexadecimalErrorCode) {
            return undefined;
        }
        return parseInt(hexadecimalErrorCode, 16);
    }
}